// File: frontend/src/mocks/reinsurance/contractsData.js

export const mockContractsList = {
  success: true,
  count: 5,
  data: [
    { 
      contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f", 
      contract_number: "RIL-240315-789", 
      rnr: "RNR5A3F2",
      cedent: { cedent_name: "Global Insurance Co." }, 
      contract_type: "property", 
      contract_structure: "non_proportional",
      terms: { 
        effective_date: "2025-01-01T00:00:00Z", 
        expiration_date: "2025-12-31T23:59:59Z",
        limit: 15000000,
        premium: { base_amount: 2250000 }
      },
      performance: { current_status: "active" } 
    },
    { 
      contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p", 
      contract_number: "RIL-240422-456", 
      rnr: "RNR7B2D9",
      cedent: { cedent_name: "Pacific Mutual" }, 
      contract_type: "specialty", 
      contract_structure: "proportional",
      terms: { 
        effective_date: "2025-02-15T00:00:00Z", 
        expiration_date: "2026-02-14T23:59:59Z",
        limit: 10000000,
        premium: { base_amount: 1500000 }
      },
      performance: { current_status: "active" } 
    },
    { 
      contract_id: "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p", 
      contract_number: "RIL-240501-123", 
      rnr: "RNR3K9P7",
      cedent: { cedent_name: "Atlantic Re" }, 
      contract_type: "parametric", 
      contract_structure: "hybrid",
      terms: { 
        effective_date: "2025-03-01T00:00:00Z", 
        expiration_date: "2026-02-28T23:59:59Z",
        limit: 20000000,
        premium: { base_amount: 3000000 }
      },
      performance: { current_status: "bound" } 
    },
    { 
      contract_id: "q7r8s9t0-u1v2-w3x4-y5z6-a7b8c9d0e1f2", 
      contract_number: "RIL-250115-234", 
      rnr: "RNR8F4G2",
      cedent: { cedent_name: "Midwest Insurance" }, 
      contract_type: "property", 
      contract_structure: "non_proportional",
      terms: { 
        effective_date: "2025-04-15T00:00:00Z", 
        expiration_date: "2026-04-14T23:59:59Z",
        limit: 12000000,
        premium: { base_amount: 1800000 }
      },
      performance: { current_status: "active" } 
    },
    { 
      contract_id: "g3h4i5j6-k7l8-m9n0-o1p2-q3r4s5t6u7v8", 
      contract_number: "RIL-250220-567", 
      rnr: "RNR2P9L5",
      cedent: { cedent_name: "European Assurance" }, 
      contract_type: "facultative", 
      contract_structure: "proportional",
      terms: { 
        effective_date: "2025-05-01T00:00:00Z", 
        expiration_date: "2026-04-30T23:59:59Z",
        limit: 18000000,
        premium: { base_amount: 2700000 }
      },
      performance: { current_status: "draft" } 
    }
  ]
};

export const mockContractDetails = {
  "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f": {
    success: true,
    data: {
      contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
      contract_number: "RIL-240315-789",
      rnr: "RNR5A3F2",
      contract_type: "property",
      contract_subtype: "catastrophe",
      contract_structure: "non_proportional",
      cedent: {
        cedent_id: "ced1-4a5b-6c7d-8e9f0a1b2c3d",
        cedent_name: "Global Insurance Co.",
        cedent_domicile: "Bermuda",
        cedent_rating: {
          am_best: "A",
          sp: "A+",
          moodys: "A2",
          fitch: "A"
        }
      },
      broker: {
        broker_id: "brk1-7e8f-9g0h-1i2j3k4l5m6n",
        broker_name: "Reinsurance Brokers Ltd.",
        broker_contact: {
          name: "John Smith",
          email: "john.smith@rebrokers.com",
          phone: "+1-555-123-4567"
        },
        broker_commission: {
          percentage: 10,
          amount: 225000,
          currency: "USD"
        }
      },
      terms: {
        effective_date: "2025-01-01T00:00:00Z",
        expiration_date: "2025-12-31T23:59:59Z",
        currency: "USD",
        limit: 15000000,
        attachment_point: 5000000,
        premium: {
          base_amount: 2250000,
          adjustable: true,
          adjustment_basis: "Exposure",
          minimum_premium: 1800000,
          deposit_premium: 2250000,
          final_premium: null
        },
        premium_payment_schedule: [
          {
            due_date: "2025-01-15T00:00:00Z",
            amount: 1125000,
            currency: "USD",
            status: "paid"
          },
          {
            due_date: "2025-07-15T00:00:00Z",
            amount: 1125000,
            currency: "USD",
            status: "pending"
          }
        ],
        reinstatements: [
          {
            number: 1,
            premium_percentage: 100,
            coverage_percentage: 100,
            used: false
          }
        ],
        exclusions: [
          {
            exclusion_id: "excl1-9a8b-7c6d-5e4f3g2h1i0j",
            exclusion_type: "Cyber",
            exclusion_description: "All cyber-related losses are excluded"
          },
          {
            exclusion_id: "excl2-3k4l-5m6n-7o8p9q0r1s2t",
            exclusion_type: "Nuclear",
            exclusion_description: "All nuclear-related losses are excluded"
          }
        ],
        special_conditions: [
          {
            condition_id: "cond1-2u3v-4w5x-6y7z8a9b0c1d",
            condition_type: "Claims Cooperation",
            condition_description: "Cedent must notify reinsurer of all claims within 30 days"
          }
        ],
        profit_commission: {
          applicable: true,
          percentage: 15,
          calculation_basis: "Underwriting Year"
        }
      },
      risk: {
        covered_perils: ["hurricane", "earthquake", "flood"],
        territories: ["US", "CA"],
        exposure_data: {
          total_insured_value: 750000000,
          number_of_risks: 1500,
          average_value_per_risk: 500000,
          exposure_by_territory: {
            US: 600000000,
            CA: 150000000
          },
          exposure_by_peril: {
            hurricane: 450000000,
            earthquake: 225000000,
            flood: 75000000
          }
        },
        modeling_results: [
          {
            model_id: "mod1-2e3f-4g5h-6i7j8k9l0m1n",
            model_name: "RMS",
            model_version: "23.0",
            expected_loss: 1125000,
            standard_deviation: 3750000,
            coefficient_of_variation: 3.33,
            exceedance_probability: {
              "1_in_10": 2250000,
              "1_in_20": 4500000,
              "1_in_50": 9000000,
              "1_in_100": 12750000,
              "1_in_250": 18000000,
              "1_in_500": 22500000,
              "1_in_1000": 27000000
            },
            tail_value_at_risk: 14250000,
            modeling_date: "2024-12-15T00:00:00Z"
          }
        ],
        expected_loss: 1125000,
        probable_maximum_loss: 12750000,
        risk_metrics: {
          loss_ratio: 50,
          rate_on_line: 15,
          return_period: 20,
          technical_price: 2025000
        }
      },
      capital_allocation: {
        total_allocated: 12000000,
        allocations: [
          {
            capital_id: "a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6",
            investor_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
            investor_name: "ILS Fund Alpha",
            amount: 8000000,
            percentage: 53.33,
            expected_return: 12.5,
            allocation_id: "w9x0y1z2-a3b4-c5d6-e7f8-g9h0i1j2k3l4"
          },
          {
            capital_id: "q7r8s9t0-u1v2-w3x4-y5z6-a7b8c9d0e1f2",
            investor_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
            investor_name: "ILS Fund Alpha",
            amount: 4000000,
            percentage: 26.67,
            expected_return: 11.8,
            allocation_id: "m5n6o7p8-q9r0-s1t2-u3v4-w5x6y7z8a9b0"
          }
        ],
        collateral_requirements: {
          total_required: 15000000,
          posted: 15000000,
          release_conditions: "Upon expiration or commutation"
        },
        trust_account: {
          account_id: "trust1-2o3p-4q5r-6s7t8u9v0w1x",
          account_name: "Reinsurance Trust Account",
          bank_name: "Global Bank",
          account_balance: 15000000
        }
      },
      performance: {
        current_status: "active",
        loss_ratio: 33.33,
        claims: [
          {
            claim_id: "d1e2f3g4-h5i6-j7k8-l9m0-n1o2p3q4r5s6",
            claim_number: "CLM-250412-001",
            incurred_loss: 3500000,
            paid_loss: 1750000,
            claim_status: "in_process"
          },
          {
            claim_id: "p5q6r7s8-t9u0-v1w2-x3y4-z5a6b7c8d9e0",
            claim_number: "CLM-250220-004",
            incurred_loss: 1500000,
            paid_loss: 750000,
            claim_status: "in_process"
          }
        ],
        reserves: {
          case_reserves: 2500000,
          ibnr_reserves: 750000,
          total_reserves: 3250000
        },
        incurred_losses: 5000000,
        paid_losses: 2500000,
        underwriting_result: 1500000
      },
      metadata: {
        created_at: "2024-12-15T10:30:00Z",
        updated_at: "2025-04-20T14:45:00Z",
        created_by: "user123",
        updated_by: "user456",
        version: 3,
        workflow_status: "approved",
        approval_status: "approved",
        notes: [
          "Contract renewed from previous year with 5% rate increase",
          "Special terms negotiated for cyber exclusion"
        ],
        tags: ["property", "catastrophe", "US", "CA"]
      }
    }
  },
  "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p": {
    success: true,
    data: {
      contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p",
      contract_number: "RIL-240422-456",
      rnr: "RNR7B2D9",
      contract_type: "specialty",
      contract_subtype: "marine",
      contract_structure: "proportional",
      cedent: {
        cedent_id: "ced2-5y6z-7a8b-9c0d1e2f3g4h",
        cedent_name: "Pacific Mutual",
        cedent_domicile: "Singapore",
        cedent_rating: {
          am_best: "A-",
          sp: "A",
          moodys: "A3",
          fitch: "A-"
        }
      },
      broker: {
        broker_id: "brk2-8i9j-0k1l-2m3n4o5p6q7r",
        broker_name: "Marine Reinsurance Brokers",
        broker_contact: {
          name: "Sarah Johnson",
          email: "sarah.johnson@marinebrokers.com",
          phone: "+65-9876-5432"
        },
        broker_commission: {
          percentage: 12,
          amount: 180000,
          currency: "USD"
        }
      },
      terms: {
        effective_date: "2025-02-15T00:00:00Z",
        expiration_date: "2026-02-14T23:59:59Z",
        currency: "USD",
        limit: 10000000,
        attachment_point: 0,
        premium: {
          base_amount: 1500000,
          adjustable: true,
          adjustment_basis: "Premium Income",
          minimum_premium: 1200000,
          deposit_premium: 1500000,
          final_premium: null
        },
        premium_payment_schedule: [
          {
            due_date: "2025-03-01T00:00:00Z",
            amount: 750000,
            currency: "USD",
            status: "paid"
          },
          {
            due_date: "2025-09-01T00:00:00Z",
            amount: 750000,
            currency: "USD",
            status: "pending"
          }
        ],
        reinstatements: [],
        exclusions: [
          {
            exclusion_id: "excl3-0s1t-2u3v-4w5x6y7z8a9b",
            exclusion_type: "War",
            exclusion_description: "War and civil war risks are excluded"
          }
        ],
        special_conditions: [
          {
            condition_id: "cond2-1c2d-3e4f-5g6h7i8j9k0l",
            condition_type: "Profit Commission",
            condition_description: "20% profit commission payable if loss ratio is below 70%"
          }
        ],
        profit_commission: {
          applicable: true,
          percentage: 20,
          calculation_basis: "Underwriting Year"
        }
      },
      risk: {
        covered_perils: ["marine", "cargo", "hull"],
        territories: ["GLOBAL"],
        exposure_data: {
          total_insured_value: 350000000,
          number_of_risks: 700,
          average_value_per_risk: 500000,
          exposure_by_territory: {
            GLOBAL: 350000000
          },
          exposure_by_peril: {
            marine: 210000000,
            cargo: 105000000,
            hull: 35000000
          }
        },
        modeling_results: [],
        expected_loss: 900000,
        probable_maximum_loss: 5000000,
        risk_metrics: {
          loss_ratio: 60,
          rate_on_line: 15,
          return_period: 10,
          technical_price: 1350000
        }
      },
      capital_allocation: {
        total_allocated: 8000000,
        allocations: [
          {
            capital_id: "a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6",
            investor_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
            investor_name: "ILS Fund Alpha",
            amount: 5000000,
            percentage: 50,
            expected_return: 14.2,
            allocation_id: "c1d2e3f4-g5h6-i7j8-k9l0-m1n2o3p4q5r6"
          },
          {
            capital_id: "g3h4i5j6-k7l8-m9n0-o1p2-q3r4s5t6u7v8",
            investor_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
            investor_name: "ILS Fund Alpha",
            amount: 3000000,
            percentage: 30,
            expected_return: 13.5,
            allocation_id: "s7t8u9v0-w1x2-y3z4-a5b6-c7d8e9f0g1h2"
          }
        ],
        collateral_requirements: {
          total_required: 10000000,
          posted: 10000000,
          release_conditions: "Upon expiration or commutation"
        },
        trust_account: {
          account_id: "trust2-3m4n-5o6p-7q8r9s0t1u2v",
          account_name: "Marine Reinsurance Trust",
          bank_name: "Singapore Bank",
          account_balance: 10000000
        }
      },
      performance: {
        current_status: "active",
        loss_ratio: 33.33,
        claims: [
          {
            claim_id: "t7u8v9w0-x1y2-z3a4-b5c6-d7e8f9g0h1i2",
            claim_number: "CLM-250428-002",
            incurred_loss: 2800000,
            paid_loss: 0,
            claim_status: "reported"
          },
          {
            claim_id: "v7w8x9y0-z1a2-b3c4-d5e6-f7g8h9i0j1k2",
            claim_number: "CLM-250401-005",
            incurred_loss: 2200000,
            paid_loss: 0,
            claim_status: "reported"
          }
        ],
        reserves: {
          case_reserves: 5000000,
          ibnr_reserves: 0,
          total_reserves: 5000000
        },
        incurred_losses: 5000000,
        paid_losses: 0,
        underwriting_result: 500000
      },
      metadata: {
        created_at: "2025-01-20T09:15:00Z",
        updated_at: "2025-04-28T11:30:00Z",
        created_by: "user789",
        updated_by: "user456",
        version: 2,
        workflow_status: "approved",
        approval_status: "approved",
        notes: [
          "New marine treaty with Pacific Mutual",
          "Focus on APAC shipping routes"
        ],
        tags: ["specialty", "marine", "global", "proportional"]
      }
    }
  },
  "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p": {
    success: true,
    data: {
      contract_id: "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p",
      contract_number: "RIL-240501-123",
      rnr: "RNR3K9P7",
      contract_type: "parametric",
      contract_subtype: "earthquake",
      contract_structure: "hybrid",
      cedent: {
        cedent_id: "ced3-6a7b-8c9d-0e1f2g3h4i5j",
        cedent_name: "Atlantic Re",
        cedent_domicile: "Bermuda",
        cedent_rating: {
          am_best: "A",
          sp: "A",
          moodys: "A2",
          fitch: "A"
        }
      },
      broker: {
        broker_id: "brk3-9k0l-1m2n-3o4p5q6r7s8t",
        broker_name: "Global Reinsurance Brokers",
        broker_contact: {
          name: "Michael Chen",
          email: "michael.chen@globalrebrokers.com",
          phone: "+1-555-987-6543"
        },
        broker_commission: {
          percentage: 8,
          amount: 240000,
          currency: "USD"
        }
      },
      terms: {
        effective_date: "2025-03-01T00:00:00Z",
        expiration_date: "2026-02-28T23:59:59Z",
        currency: "USD",
        limit: 20000000,
        attachment_point: 0,
        premium: {
          base_amount: 3000000,
          adjustable: false,
          adjustment_basis: null,
          minimum_premium: 3000000,
          deposit_premium: 3000000,
          final_premium: null
        },
        premium_payment_schedule: [
          {
            due_date: "2025-03-15T00:00:00Z",
            amount: 3000000,
            currency: "USD",
            status: "paid"
          }
        ],
        reinstatements: [],
        exclusions: [],
        special_conditions: [
          {
            condition_id: "cond3-2w3x-4y5z-6a7b8c9d0e1f",
            condition_type: "Parametric Trigger",
            condition_description: "Payment triggered by earthquake magnitude as reported by USGS"
          }
        ],
        profit_commission: {
          applicable: false,
          percentage: null,
          calculation_basis: null
        }
      },
      risk: {
        covered_perils: ["earthquake"],
        territories: ["JP", "US", "NZ"],
        exposure_data: {
          total_insured_value: 500000000,
          number_of_risks: 3,
          average_value_per_risk: 166666667,
          exposure_by_territory: {
            JP: 250000000,
            US: 150000000,
            NZ: 100000000
          },
          exposure_by_peril: {
            earthquake: 500000000
          }
        },
        modeling_results: [
          {
            model_id: "mod2-3w4x-5y6z-7a8b9c0d1e2f",
            model_name: "AIR",
            model_version: "2024",
            expected_loss: 1800000,
            standard_deviation: 6000000,
            coefficient_of_variation: 3.33,
            exceedance_probability: {
              "1_in_10": 3600000,
              "1_in_20": 7200000,
              "1_in_50": 14400000,
              "1_in_100": 20000000,
              "1_in_250": 20000000,
              "1_in_500": 20000000,
              "1_in_1000": 20000000
            },
            tail_value_at_risk: 20000000,
            modeling_date: "2025-02-10T00:00:00Z"
          }
        ],
        expected_loss: 1800000,
        probable_maximum_loss: 20000000,
        risk_metrics: {
          loss_ratio: 60,
          rate_on_line: 15,
          return_period: 100,
          technical_price: 2700000
        }
      },
      capital_allocation: {
        total_allocated: 16000000,
        allocations: [
          {
            capital_id: "a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6",
            investor_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
            investor_name: "ILS Fund Alpha",
            amount: 6000000,
            percentage: 30,
            expected_return: 15.3,
            allocation_id: "i3j4k5l6-m7n8-o9p0-q1r2-s3t4u5v6w7x8"
          },
          {
            capital_id: "q7r8s9t0-u1v2-w3x4-y5z6-a7b8c9d0e1f2",
            investor_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
            investor_name: "ILS Fund Alpha",
            amount: 5000000,
            percentage: 25,
            expected_return: 14.8,
            allocation_id: "y9z0a1b2-c3d4-e5f6-g7h8-i9j0k1l2m3n4"
          },
          {
            capital_id: "g3h4i5j6-k7l8-m9n0-o1p2-q3r4s5t6u7v8",
            investor_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
            investor_name: "ILS Fund Alpha",
            amount: 5000000,
            percentage: 25,
            expected_return: 14.5,
            allocation_id: "o5p6q7r8-s9t0-u1v2-w3x4-y5z6a7b8c9d0"
          }
        ],
        collateral_requirements: {
          total_required: 20000000,
          posted: 20000000,
          release_conditions: "Upon expiration or commutation"
        },
        trust_account: {
          account_id: "trust3-4q5r-6s7t-8u9v0w1x2y3z",
          account_name: "Parametric Reinsurance Trust",
          bank_name: "International Bank",
          account_balance: 20000000
        }
      },
      performance: {
        current_status: "bound",
        loss_ratio: 83.33,
        claims: [
          {
            claim_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
            claim_number: "CLM-250315-003",
            incurred_loss: 2500000,
            paid_loss: 1250000,
            claim_status: "in_process"
          }
        ],
        reserves: {
          case_reserves: 1250000,
          ibnr_reserves: 0,
          total_reserves: 1250000
        },
        incurred_losses: 2500000,
        paid_losses: 1250000,
        underwriting_result: 500000
      },
      metadata: {
        created_at: "2025-02-15T11:45:00Z",
        updated_at: "2025-04-01T16:20:00Z",
        created_by: "user123",
        updated_by: "user789",
        version: 2,
        workflow_status: "approved",
        approval_status: "approved",
        notes: [
          "Parametric earthquake cover for key locations",
          "Trigger set at magnitude 7.0 or greater"
        ],
        tags: ["parametric", "earthquake", "JP", "US", "NZ"]
      }
    }
  }
};

export const mockCreateContractResponse = {
  success: true,
  message: "Contract created successfully",
  data: {
    contract_id: "w9x0y1z2-a3b4-c5d6-e7f8-g9h0i1j2k3l4",
    contract_number: "RIL-250503-890",
    rnr: "RNR6D2H7"
  }
};

export const mockUpdateContractResponse = {
  success: true,
  message: "Contract updated successfully",
  data: {
    contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
    contract_number: "RIL-240315-789",
    rnr: "RNR5A3F2",
    version: 4
  }
};

export const mockVerifyRNRResponse = {
  success: true,
  contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
  contract_number: "RIL-240315-789",
  contract_type: "property",
  current_status: "active",
  created_at: "2024-12-15T10:30:00Z",
  cedent_name: "Global Insurance Co.",
  effective_date: "2025-01-01T00:00:00Z",
  expiration_date: "2025-12-31T23:59:59Z",
  message: "RNR verification successful"
};